// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs-navigation {
  margin-bottom: 2rem;
  background: #fff;
  padding: 0 60px;
}

.tabs-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  background: transparent;
  overflow-x: auto;
}

.tab-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 10px 15px;
  margin: 0 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  white-space: nowrap;
}

.tab-button:first-child {
  margin-left: 0;
}

.tab-button:last-child {
  margin-right: 0;
}

.tab-button:hover {
  color: #f09500;
  transform: scale(1.05);
}

.tab-button.active {
  color: #333;
  font-weight: 600;
}

.tab-label {
  font-size: 14px;
  font-weight: inherit;
  text-align: center;
  line-height: 1.2;
  font-family: 'Montserrat', sans-serif;
}

.tabs-indicator {
  position: relative;
  width: 100%;
  height: 3px;
  background-color: #e0e0e0;
  margin-top: 2px;
  padding: 0 60px;
}

.indicator-line {
  position: absolute;
  height: 100%;
  background-color: #f09500;
  transition: width 0.3s ease, left 0.3s ease;
  bottom: 0;
  border-radius: 2px;
}

@media (max-width: 768px) {
  .tabs-navigation {
    padding: 0 30px;
  }
  
  .tabs-container {
    padding: 15px 0;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  .tab-button {
    margin: 0 10px;
    padding: 8px 12px;
    font-size: 14px;
    flex-shrink: 0;
  }
  
  .tab-label {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/new-proyect/new-project-tabs/new-project-tabs.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".tabs-navigation {\n  margin-bottom: 2rem;\n  background: #fff;\n  padding: 0 60px;\n}\n\n.tabs-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 0;\n  background: transparent;\n  overflow-x: auto;\n}\n\n.tab-button {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  padding: 10px 15px;\n  margin: 0 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.tab-button:first-child {\n  margin-left: 0;\n}\n\n.tab-button:last-child {\n  margin-right: 0;\n}\n\n.tab-button:hover {\n  color: #f09500;\n  transform: scale(1.05);\n}\n\n.tab-button.active {\n  color: #333;\n  font-weight: 600;\n}\n\n.tab-label {\n  font-size: 14px;\n  font-weight: inherit;\n  text-align: center;\n  line-height: 1.2;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.tabs-indicator {\n  position: relative;\n  width: 100%;\n  height: 3px;\n  background-color: #e0e0e0;\n  margin-top: 2px;\n  padding: 0 60px;\n}\n\n.indicator-line {\n  position: absolute;\n  height: 100%;\n  background-color: #f09500;\n  transition: width 0.3s ease, left 0.3s ease;\n  bottom: 0;\n  border-radius: 2px;\n}\n\n@media (max-width: 768px) {\n  .tabs-navigation {\n    padding: 0 30px;\n  }\n  \n  .tabs-container {\n    padding: 15px 0;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  \n  .tab-button {\n    margin: 0 10px;\n    padding: 8px 12px;\n    font-size: 14px;\n    flex-shrink: 0;\n  }\n  \n  .tab-label {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
